import { MutationType } from '@tencent/slide-sdk-model';

// 最大可回退的次数，这个数据是参考 sdk 的限制
export const MaxUndos = 100;

// sdk 中和文本相关的操作类型
export const TextMutations = [
    MutationType.InsertText,
    MutationType.DeleteText,
    MutationType.SetTextProperties,
    MutationType.SetTextData,
    MutationType.SetTextBodyProperties,
];
